import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare /admin/courses/:id (and /admin/courses/new) is just an entry point — send
// to the Info tab, the default editing surface (mirrors the web-admin shell which
// defaults to Info). Works for both existing courses and the `new` create flow.
export const Route = createFileRoute('/admin/courses_/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/admin/courses/$id/info', params: { id: params.id } });
  },
});
